<template>
  <b-container fluid>
    <b-row style="margin-top: 4em">
      <b-col>
        <h2 class="text-secondary">
          {{ $t("globals.all_installations") + " " }}
          <icon v-if="getInstallationFormsLoading" name="spinner" spin></icon>
        </h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="my-3">
        <b-input-group>
          <b-form-input
            v-model="filter"
            :placeholder="$t('globals.type_to_search')"
          />
          <b-input-group-append>
            <b-btn variant="warning" :disabled="!filter" @click="filter = ''">
              {{ $t("globals.clear") }}
            </b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col cols="2" class="my-3">
        <b-form-select v-model="perPage" :options="perPageOptions" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          small
          primary-key="id"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :current-page="currentPage"
          :per-page="perPage"
          :items="getInstallationForms"
          :fields="fields"
          @filtered="onFiltered"
          @sort-changed="sortingChanged"
        >
          <template v-slot:cell(make_model)="item">
            <div v-b-tooltip.hover :title="item.item.make">
              {{ item.item.model }}
            </div>
          </template>
          <template v-slot:cell(updated_at)="item">
            <div v-b-tooltip.hover :title="item.item.updated_at">
              {{ item.item.updated_at.substring(0, 10) }}
            </div>
          </template>
          <template v-slot:cell(created_at)="item">
            <div v-b-tooltip.hover :title="item.item.created_at">
              {{ item.item.created_at.substring(0, 10) }}
            </div>
          </template>
          <template v-slot:cell(notes)="item" size="lg">
            <div v-b-tooltip.hover :title="item.item.notes">
              {{
                item.item.notes.length > 20
                  ? item.item.notes.substring(0, 20) + "..."
                  : item.item.notes
              }}
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <b-btn
              variant="info"
              size="sm"
              class="float-right mx-1"
              @click="goToInstallationForm(row.item.id)"
            >
              {{ $t("globals.ins_form") }}
            </b-btn>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="my-1">
        <b-pagination
          :total-rows="getInstallationForms.length"
          :per-page="perPage"
          v-model="currentPage"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import "vue-awesome/icons/spinner";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue")
  },
  data() {
    return {
      table: {
        offset: 0,
        limit: 99999, // Temporary before implementing pagination
        order_by: "updated_at DESC"
      },
      filter: null,
      currentPage: 1,
      perPage: 20,
      sortBy: "updated_at",
      sortDesc: true,
      perPageOptions: [
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "40 " + this.$t("globals.per_page"), value: 40 },
        { text: "60 " + this.$t("globals.per_page"), value: 60 }
      ],
      fields: [
        {
          key: "id",
          sortable: true
        },
        {
          key: "imei",
          sortable: true
        },
        {
          key: "user",
          sortable: true
        },
        {
          key: "license",
          sortable: true
        },
        {
          key: "make_model",
          label: this.$t("globals.make"),
          sortable: false
        },
        {
          key: "installation_type",
          label: this.$t("globals.installation_type"),
          sortable: true
        },
        {
          key: "status",
          label: this.$t("globals.status"),
          sortable: true
        },
        {
          key: "billing_info_type",
          label: "Info",
          sortable: true
        },
        {
          key: "customer",
          label: this.$t("globals.customer"),
          sortable: true
        },
        {
          key: "connection_status",
          label: this.$t("globals.connection_status"),
          sortable: true
        },
        {
          key: "updated_at",
          label: this.$t("globals.updated_at"),
          sortable: true
        },
        {
          key: "created_at",
          label: this.$t("globals.created_at"),
          sortable: true
        },
        {
          key: "notes",
          label: this.$t("globals.notes"),
          sortable: false
        },
        {
          key: "actions",
          label: this.$t("globals.actions"),
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapGetters("installation_forms", [
      "getInstallationForms",
      "getInstallationFormsLoading"
    ]),
    ...mapGetters(["getUserBrandPermissions", "getWebAppUrl"])
  },
  methods: {
    ...mapActions("installation_forms", ["fetchInstallationForms"]),
    goToInstallationForm(id) {
      window.open(
        `${this.getWebAppUrl}/admin/device_installations/${id}`,
        "_blank"
      );
    },
    onFiltered() {
      this.currentPage = 1;
    },
    sortingChanged(ctx) {
      // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
      // ctx.sortDesc ==> true if sorting descending, false otherwise

      /*
      this.table.order_by = ctx.sortBy;
      if (ctx.sortDesc) {
        this.table.order_by += " DESC";
      } else {
        this.table.order_by += " ASC";
      }

      this.table.offset = 0;

      this.fetchInstallationForms({
        limit: this.table.limit,
        offset: this.table.offset,
        order_by: this.table.order_by
      });
      */
    }
  },
  mounted() {
    this.fetchInstallationForms({ limit: this.table.limit });
  },
  created() {
    if (!this.getUserBrandPermissions.installations_index) {
      this.$router.push({ name: "dashboard" });
    }
  }
};
</script>
